export const blockIconsAudioandvideoVolumeMute = (
	<span className='material-symbols-outlined'>volume_mute</span>
);
